import { render, staticRenderFns } from "./Casovi.vue?vue&type=template&id=46d78cee&"
import script from "./Casovi.vue?vue&type=script&lang=js&"
export * from "./Casovi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports